import { useEffect, useRef, useState, useCallback } from 'react';
import { apiImageUrl } from '../utils/streamApi';

// Lightweight checkpoint preview — live camera frame + the drawn zone, NO pose.
// Cheap (just a frame poll + a polygon), used by the Guard view where the real
// check-in status comes from /ui/patrol/status. `highlight` greens the zone once
// the checkpoint is done.
export default function PatrolFramePreview({ cameraIdx, polygon = [], highlight = false }) {
  const [imgUrl, setImgUrl] = useState('');
  const imgRef = useRef(null), canvasRef = useRef(null);
  const hasCam = cameraIdx !== undefined && cameraIdx !== null && cameraIdx !== '';

  const refresh = useCallback(async () => {
    if (!hasCam) return;
    try { setImgUrl(await apiImageUrl(`/cameras/${cameraIdx}/frame?ts=${Date.now()}`)); } catch { /* keep last */ }
  }, [cameraIdx, hasCam]);

  useEffect(() => { if (!hasCam) return; refresh(); const t = setInterval(refresh, 1200); return () => clearInterval(t); }, [refresh, hasCam]);
  useEffect(() => { setImgUrl(''); }, [cameraIdx]);

  const draw = useCallback(() => {
    const cv = canvasRef.current, img = imgRef.current;
    if (!cv || !img) return;
    cv.width = img.clientWidth; cv.height = img.clientHeight;
    const ctx = cv.getContext('2d'); const W = cv.width, H = cv.height; ctx.clearRect(0, 0, W, H);
    if (polygon.length >= 3) {
      ctx.beginPath(); polygon.forEach(([x, y], i) => { const px = x * W, py = y * H; i ? ctx.lineTo(px, py) : ctx.moveTo(px, py); }); ctx.closePath();
      ctx.strokeStyle = highlight ? '#5cc98a' : '#4da3ff';
      ctx.fillStyle = highlight ? 'rgba(92,201,138,0.20)' : 'rgba(77,163,255,0.12)';
      ctx.lineWidth = 2; ctx.fill(); ctx.stroke();
    }
  }, [polygon, highlight]);

  useEffect(() => { draw(); }, [draw, imgUrl]);

  return (
    <div style={{ position: 'relative', width: '100%', background: '#000', border: '1px solid var(--border)', borderRadius: 8, overflow: 'hidden' }}>
      {imgUrl
        ? <img ref={imgRef} src={imgUrl} alt="checkpoint" onLoad={draw} style={{ display: 'block', width: '100%', height: 'auto' }} />
        : <div style={{ padding: 30, textAlign: 'center', color: 'var(--text-muted)' }}>Loading camera…</div>}
      <canvas ref={canvasRef} style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', pointerEvents: 'none' }} />
    </div>
  );
}
